import Smart from './Smart.vue';

export default Smart;



// WEBPACK FOOTER //
// ./src/pages/profile/views/cabinet/components/smart/index.ts